/* lw-cart-autoopen.js
 * Öffnet automatisch den Side-Cart, wenn URL ?open_cart=1 enthält.
 * Verwendet: Klaviyo Cart-Recovery-Mails (4.1, 4.2) als Fallback,
 * wenn event.extra.checkout_url leer ist.
 *
 * Einbau: in theme.liquid vor </body>
 *   {{ 'lw-cart-autoopen.js' | asset_url | script_tag }}
 */
(function () {
  'use strict';
  try {
    var params = new URLSearchParams(window.location.search);
    if (params.get('open_cart') !== '1') return;

    var attempts = 0;
    var maxAttempts = 40; // ~8s Window, falls Drawer-JS spät lädt

    function tryOpen() {
      attempts++;
      if (window.LWCartDrawer && typeof window.LWCartDrawer.open === 'function') {
        window.LWCartDrawer.open();
        cleanUrl();
        return true;
      }
      if (attempts >= maxAttempts) {
        cleanUrl();
        return true;
      }
      return false;
    }

    function cleanUrl() {
      try {
        var url = new URL(window.location.href);
        url.searchParams.delete('open_cart');
        window.history.replaceState({}, document.title, url.toString());
      } catch (e) {}
    }

    function start() {
      if (tryOpen()) return;
      var iv = setInterval(function () {
        if (tryOpen()) clearInterval(iv);
      }, 200);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  } catch (e) {
    // Silent fail, niemals Page brechen
  }
})();